import { planningAPI } from "../../axios";

export const actions = {
    //Planning Template
    GetPlanningTemplate(context, data){
        return planningAPI.get(`PlanningTemplate/Campus/${data}`);
    },
    UpdatePlanningTemplate(context, data){
        return planningAPI.put(`PlanningTemplate/Update/${data.id}`, data);
    },
    DeletePlanningTemplate(context, data){
        return planningAPI.delete(`PlanningTemplate/Delete/${data}`);
    },
    CreatePlanningTemplate(context, data){
        return planningAPI.post(`PlanningTemplate/Create`, data);
    },
    SendPlanningTemplate(context, data){
        return planningAPI.post(`PlanningTemplate/Send/${data.id}/${data.cycle}/${data.isPrePlanning}`);
    },
}